import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  iconRoot: {
    '&:hover, &:focus': {
      backgroundColor: '#fff',
    },
    '& .icon': {
      color: '#c8c8c8',
      opacity: 1,
    },
    backgroundColor: '#fff',
    color: 'white',
    borderRadius: 3,
  },
  gridPosition: {
    float: 'right',
    margin: '-.5rem -1rem 0 0',
  },
  listPosition: {
    padding: 0,
    fontSize: '19px !important;',
    fontWeight: 500,
    color: '#646464',
  },
  menuPaper: {
    borderRadius: 1,
    width: '12rem',
    padding: 0,
  },
  button: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 0,
    tabIndex: 0,
    color: 'black',
    fontFamily: 'inherit',
    padding: '0 0 0 1rem',
    height: '2rem',
    maxWidth: '250px',
    '&:hover': {
      backgroundColor: '#ececec',
    },
  },
});

const TextIconMenu = ({ actionMenu, gridMode, listMode, title }) => {
  const classes = useStyles({ listMode });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const menuRef = React.createRef();

  const handleClick = e => {
    setAnchorEl(e.currentTarget);
    menuRef.current.focus();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        disableRipple
        onClick={handleClick}
        className={[
          classes.iconRoot,
          gridMode ? classes.gridPosition : null,
          listMode ? classes.listPosition : null,
        ].join(' ')}
      >
        {title}
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        MenuListProps={{
          disablePadding: true,
        }}
        classes={{
          paper: classes.menuPaper,
        }}
        ref={menuRef}
      >
        {actionMenu.map(item => (
          <MenuItem
            onClose={handleClose}
            onClick={() => {
              item.handleClick();
              handleClose();
            }}
            className={classes.button}
          >
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

TextIconMenu.propTypes = {
  actionMenu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      handleClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  gridMode: PropTypes.bool,
  listMode: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

TextIconMenu.defaultProps = {
  gridMode: false,
  listMode: false,
};

export default TextIconMenu;
